import get from "lodash/get";

export const stringValueGetter = ({ data, colDef: { field } }) => {
  if (!data) {
    return null;
  }

  const value = field.includes(".") ? get(data, field) : data[field];
  return value === null || value === undefined ? "" : value.toString();
};

export const searchableStringQuickFilterTextGetter = params => {
  const { value } = params;
  if (value == null) {
    return "";
  }
  if (Array.isArray(value)) {
    return value.join(" ").replace(/[^\w\s]/g, "");
  }
  if (typeof value === "object") {
    return "";
  }
  if (typeof value !== "string") {
    return String(value);
  }
  return value.replace(/[^\w\s]/g, "");
};
